<template>
  <footer class="footer">

    <!-- ── Corps du footer ─────────────────────────── -->
    <div class="footer-body">

      <!-- Colonne 1 : identité -->
      <div class="footer-col footer-col--brand">
        <div class="footer-logo-text">
          <em>Bamboo</em> Sushi
        </div>
        <p class="footer-tagline">{{ t('tagline_restaurant') }}</p>
        <p class="footer-desc">
          {{ t('footer_desc') }}
        </p>
        <div class="footer-socials">
          <a
            href="https://www.facebook.com/profile.php?id=100063559811742"
            target="_blank"
            rel="noopener"
            class="footer-social-circle"
            :aria-label="t('footer_facebook_aria')"
          >
            <img :src="facebookIcon" alt="Facebook" />
          </a>
          <div class="footer-social-circle" :aria-label="t('footer_takeaway_aria')">
            <img :src="emporterIcon" :alt="t('footer_takeaway_aria')" />
          </div>
        </div>
      </div>

      <!-- Colonne 2 : horaires -->
      <div class="footer-col">
        <div class="footer-section-label">{{ t('footer_hours_label') }}</div>
        <div class="footer-divider"></div>

        <div class="footer-horaire-row">
          <span>{{ t('footer_days_tue_thu') }}</span>
          <span>12h-14h · 19h-22h</span>
        </div>
        <div class="footer-horaire-row">
          <span>{{ t('footer_days_fri') }}</span>
          <span>19h-22h</span>
        </div>
        <div class="footer-horaire-row">
          <span>{{ t('footer_days_sat') }}</span>
          <span>19h-22h</span>
        </div>
        <div class="footer-horaire-row footer-horaire-row--ferme">
          <span>{{ t('footer_days_sun_mon') }}</span>
          <span>{{ t('footer_closed') }}</span>
        </div>

        <p class="footer-alerte">{{ t('footer_alert_closed_lunch') }}</p>
        <p class="footer-note">
          {{ t('footer_note_hours') }}
        </p>
      </div>

      <!-- Colonne 3 : contact + légal -->
      <div class="footer-col">
        <div class="footer-section-label">{{ t('footer_contact_label') }}</div>
        <div class="footer-divider"></div>

        <p class="footer-address">
          40 rue Docteur Laurent Camboulives<br />
          81000 Albi
        </p>
        <a href="tel:0563546609" class="footer-tel">05 63 54 66 09</a>

        <div class="footer-section-label footer-section-label--mt">{{ t('footer_legal_label') }}</div>
        <div class="footer-divider"></div>

        <ul class="footer-links">
          <li><router-link to="/mentionsLegales">{{ t('footer_link_mentions') }}</router-link></li>
          <li><router-link to="/mentionsLegales">{{ t('footer_link_confidentialite') }}</router-link></li>
          <li><router-link to="/mentionsLegales">{{ t('footer_link_cookies') }}</router-link></li>
        </ul>
      </div>

    </div>

    <!-- ── Barre de bas ────────────────────────────── -->
    <div class="footer-bar">
      <span>{{ t('footer_copyright', { year: annee }) }}</span>
      <div class="footer-bar-links">
        <router-link to="/mentionsLegales">{{ t('footer_link_mentions') }}</router-link>
        <span class="footer-bar-sep">·</span>
        <router-link to="/mentionsLegales">{{ t('footer_bar_confidentialite') }}</router-link>
        <span class="footer-bar-sep">·</span>
        <router-link to="/mentionsLegales">{{ t('footer_bar_cookies') }}</router-link>
      </div>
    </div>

  </footer>
</template>

<script setup>
import { askNotificationPermission } from '@/utils/notifications'
import { useLocale } from '@/i18n'

import facebookIcon from '@/icons/facebook.png'
import emporterIcon from '@/icons/Image-vente-à-emporter.png'

const { t } = useLocale()
const annee = new Date().getFullYear()

async function demanderNotif() {
  const token = await askNotificationPermission()
  console.log('TOKEN USER :', token)
}
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Playfair+Display:ital@0;1&display=swap');

/* ── Footer global ───────────────────────────────── */
.footer {
  width: 100%;
  background: linear-gradient(160deg, #1a1912 0%, #13130e 55%, #111110 100%);
  border-top: 1px solid rgba(200, 160, 85, 0.2);
  font-family: 'Segoe UI', sans-serif;
  color: #c0bbb2;
}

/* ── Corps ───────────────────────────────────────── */
.footer-body {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 3rem;
  max-width: 1100px;
  margin: 0 auto;
  padding: 4rem 2rem 3rem;
  flex-wrap: wrap;
}

/* ── Colonnes ────────────────────────────────────── */
.footer-col {
  flex: 1 1 220px;
}

.footer-col--brand {
  max-width: 320px;
}

/* ── Identité ────────────────────────────────────── */
.footer-logo-text {
  font-family: 'Playfair Display', serif;
  font-size: 1.6rem;
  font-weight: 400;
  color: #ede8df;
  margin-bottom: 0.4rem;
}

.footer-logo-text em {
  font-style: italic;
  color: #c8a055;
}

.footer-tagline {
  font-size: 0.68rem;
  letter-spacing: 0.2em;
  color: #706a60;
  margin: 0 0 1rem;
  text-transform: lowercase;
}

.footer-desc {
  font-size: 0.82rem;
  color: #7a7568;
  line-height: 1.75;
  margin: 0 0 1.5rem;
  font-weight: 300;
}

/* ── Icônes sociales ─────────────────────────────── */
.footer-socials {
  display: flex;
  gap: 0.75rem;
   align-items: center;
    justify-content: center;
}

.footer-social-circle {
  width: 38px;
  height: 38px;
  border-radius: 50%;
  border: 1px solid rgba(255, 255, 255, 0.15);
  display: flex;
  align-items: center;
  justify-content: center;
  text-decoration: none;
  transition: border-color 0.25s ease;
  cursor: pointer;
}

.footer-social-circle:hover {
  border-color: rgba(200, 160, 85, 0.5);
}

.footer-social-circle img {
  width: 20px;
  height: 20px;
  object-fit: contain;
}

/* ── Labels de section ───────────────────────────── */
.footer-section-label {
  font-size: 0.65rem;
  font-weight: 700;
  letter-spacing: 0.25em;
  text-transform: uppercase;
  color: #8bbf30;
  margin-bottom: 0.6rem;
}

.footer-section-label--mt {
  margin-top: 2rem;
}

.footer-divider {
  height: 1px;
  background: rgba(255, 255, 255, 0.07);
  margin-bottom: 1.25rem;
}

/* ── Horaires ────────────────────────────────────── */
.footer-horaire-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 0.82rem;
  color: #a09a90;
  padding: 0.3rem 0;
  font-weight: 300;
  gap: 1rem;
}

.footer-horaire-row--ferme {
  color: #706a60;
}

.footer-alerte {
  font-size: 0.78rem;
  color: #c0876a;
  font-style: italic;
  margin: 0.75rem 0 0.4rem;
}

.footer-note {
  font-size: 0.72rem;
  color: #4a4840;
  font-style: italic;
  line-height: 1.6;
  margin: 0;
}

/* ── Contact ─────────────────────────────────────── */
.footer-address {
  font-size: 0.85rem;
  color: #a09a90;
  line-height: 1.8;
  font-weight: 300;
  margin: 0 0 0.75rem;
}

.footer-tel {
  display: inline-block;
  font-size: 0.9rem;
  color: #c8a055;
  text-decoration: none;
  letter-spacing: 0.1em;
  transition: opacity 0.2s ease;
}

.footer-tel:hover {
  opacity: 0.7;
}

/* ── Liens légaux ────────────────────────────────── */
.footer-links {
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.footer-links a {
  font-size: 0.82rem;
  color: #7a7568;
  text-decoration: none;
  transition: color 0.2s ease;
}

.footer-links a:hover {
  color: #c8a055;
}

/* ── Barre de bas ────────────────────────────────── */
.footer-bar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 0.75rem;
  max-width: 1100px;
  margin: 0 auto;
  padding: 1.25rem 2rem;
  border-top: 1px solid rgba(255, 255, 255, 0.05);
  font-size: 0.72rem;
  color: #4a4840;
}

.footer-bar-links {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.footer-bar-links a {
  color: #4a4840;
  text-decoration: none;
  transition: color 0.2s ease;
}

.footer-bar-links a:hover {
  color: #c8a055;
}

.footer-bar-sep {
  color: #333;
}

/* ── Responsive ──────────────────────────────────── */
@media (max-width: 768px) {
  .footer-body {
    flex-direction: column;
    padding: 3rem 1.5rem 2rem;
    gap: 2.5rem;
    align-items: center;
  }

  .footer-col--brand {
    max-width: 100%;
  }

  .footer-bar {
    flex-direction: column;
    text-align: center;
    padding: 1.25rem 1.5rem;
  }
 
}
</style>
